var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { memo, useCallback, useMemo, useState, } from 'react';
import { CSSTransition } from 'react-transition-group';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { drawerGapHeight, drawerGapWidth, drawerWidth, transitionDelay, positions, } from './constants';
const defaultProps = {
    position: positions.right,
};
const DrawerTransition = (_a) => {
    var { children, position = defaultProps.position } = _a, props = __rest(_a, ["children", "position"]);
    const [height, setHeight,] = useState(0);
    const updateHeight = useCallback(({ firstChild: { clientHeight = 0, }, }) => {
        setHeight(Math
            .min(document.documentElement.clientHeight - drawerGapHeight, clientHeight));
    }, []);
    const direction = useMemo(() => (position === 'right'
        ? '+'
        : '-'), [
        position,
    ]);
    return (_jsx(ClassNames, { children: ({ css, }) => ([
            'right',
            'left',
        ].includes(position)
            ? (_jsx(CSSTransition, Object.assign({}, props, { classNames: {
                    enter: css `
                      transition-delay: ${transitionDelay}ms;
                      transform: translateX(calc(${direction}1 * ${drawerWidth}));
                      ${theme.media.lessThan('small') `
                        transform: translateX(calc(${direction}1 * (100% - ${drawerGapWidth})));
                      `};
                    `,
                    enterActive: css `
                      && {
                        ${styleUtils.transition('transform')};
                        transform: translate(0, 0);
                      }
                    `,
                    exit: css `
                      transition-delay: ${transitionDelay}ms;
                      transform: translate(0, 0);
                    `,
                    exitActive: css `
                      ${styleUtils.transition('transform')};
                      && {
                        transform: translateX(calc(${direction}1 * ${drawerWidth}));
                        ${theme.media.lessThan('small') `
                          transform: translateX(calc(${direction}1 * (100% - ${drawerGapWidth})));
                        `};
                      }
                    `,
                }, timeout: parseInt(theme.durationDefault, 10) + transitionDelay, unmountOnExit: true }, { children: children })))
            : (_jsx(CSSTransition, Object.assign({}, props, { appear: true, classNames: {
                    enter: css `
                      transition-delay: ${transitionDelay}ms;
                      height: 0;
                      overflow-y: hidden;
                    `,
                    enterActive: css `
                      ${styleUtils.transition('height')};

                      && {
                        height: ${styleUtils.rem(height)};
                      }
                      overflow-y: hidden;
                    `,
                    exit: css `
                      transition-delay: ${transitionDelay}ms;
                      height: ${styleUtils.rem(height)};
                      overflow-y: hidden;
                    `,
                    exitActive: css `
                      ${styleUtils.transition('height')};

                      && {
                        height: 0;
                      }
                      overflow-y: hidden;
                    `,
                }, onEnter: updateHeight, timeout: parseInt(theme.durationDefault, 10) + transitionDelay, unmountOnExit: true }, { children: children })))) }));
};
const MemoizedDrawerTransition = memo(DrawerTransition);
export { MemoizedDrawerTransition as DrawerTransition };
